import { render } from "./ModalRole.vue?vue&type=template&id=53e62e09"
import script from "./ModalRole.vue?vue&type=script&lang=js"
export * from "./ModalRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__